module.exports = __webpack_public_path__ + "static/img/17.68903902.jpg";